import React, { HTMLAttributes } from "react";
import cn from "classnames";

export type RowProps = HTMLAttributes<HTMLDivElement> & {
  cards?: boolean;
  center?: boolean;
};

export const Row = (props: RowProps) => {
  const { cards, center, className, ...rest } = props;

  return (
    <div
      className={cn(
        "row",
        { "row-cards": cards, "align-items-center": center },
        className
      )}
      {...rest}
    />
  );
};

export default Row;
